// 天候に応じた色の定義
export const WEATHER_COLORS = {
  sunny: "#F8B862", // 山吹色
  cloudy: "#C3B1E1", // 落ち着いた紫色
  rainy: "#A2D2FF", // 淡い青色
};

// WeatherRendererで使用される色
export const WEATHER_RENDERER_COLORS = {
  // 背景グラデーション
  background: {
    sunny: {
      top: "#87CEEB", // 空色
      bottom: "#B0E0E6", // 薄い空色
    },
    cloudy: {
      top: "#7A8B98", // 暗めのグレー
      bottom: "#9AAAB7", // 少し明るいグレー
    },
    rainy: {
      top: "#3A4556", // 暗い雨空
      bottom: "#5A6576", // やや明るい雨空
    },
  },
  // ハンドルの色
  handle: {
    outer: "#1a1a1a",
    inner: "#333333",
    highlight: "#555555",
    center: "#2a2a2a",
    centerLogo: "#444444",
  },
  // 太陽の色
  sun: {
    center: "#FFFF99",
    middle: "#FFDF00",
    outer: "#FFD700",
  },
  // 雲の色（RGBAの基本値）
  cloud: {
    sunny: [255, 255, 255], // 白い雲
    cloudy: [180, 180, 180], // グレーの雲
    rainy: [140, 140, 140], // 暗いグレーの雲
    shadowCloudy: [160, 160, 160],
    shadowRainy: [120, 120, 120],
  },
  // 雨粒の色
  raindrop: [173, 216, 230], // ライトブルー
};

// BottomPaneRendererで使用される色
export const BOTTOM_PANE_COLORS = {
  gradient: {
    dark: [40, 60, 120],
    light: [135, 206, 250],
  },
  text: "#FFDCC8",
  stepInactive: "#645078",
};

// StatusBarやその他のUI要素の色
export const UI_COLORS = {
  background: {
    dark: "#1a1a1a",
    gray: "#374151",
    lightGray: "#4B5563",
  },
  text: {
    primary: "#FFFFFF",
    secondary: "#9CA3AF",
  },
  status: {
    danger: "#EF4444",
    warning: "#F59E0B",
    success: "#10B981",
  },
};

// StatusBarで使用される色
export const STATUS_BAR_COLORS = {
  background: "#111827", // bg-gray-900
  border: "#374151", // border-gray-700
  label: "#9CA3AF", // text-gray-400
  progressBg: "#374151", // bg-gray-700
  battery: {
    low: "#EF4444", // text-red-500, bg-red-500
    medium: "#F59E0B", // text-yellow-500, bg-yellow-500
    high: "#10B981", // text-green-500, bg-green-500
  },
  distance: {
    traveled: "#60A5FA", // text-blue-400, bg-blue-500
    remaining: "#C084FC", // text-purple-400, bg-purple-500
  },
  weather: "#FB923C", // text-orange-400
  playStatus: {
    paused: {
      bg: "#4B5563", // bg-gray-600
      text: "#D1D5DB", // text-gray-300
    },
    playing: {
      bg: "#059669", // bg-green-600
      text: "#FFFFFF", // text-white
    },
  },
  warning: {
    bg: "#DC2626", // bg-red-600
    text: "#FFFFFF", // text-white
  },
};

// 天気の絵文字
export const WEATHER_EMOJI = {
  sunny: "☀️",
  cloudy: "☁️",
  rainy: "🌧️",
};

// レイアウトの定数
export const LAYOUT = {
  statusBarHeight: 128,
  statusBarHeightNormal: 64,
  barHeight: 72,
  actionBarHeight: 64,
  topPaneRatio: 0.9,
};
